import api from '../api';

class PublicAccessData {
  show(companyCourseId) {
    return api.get(`/public-access/${companyCourseId}`);
  }

  auth(companyCourseId, cpf, domain) {
    return api.post(`/public-access/${companyCourseId}/auth`, { cpf, domain });
  }
}

export default new PublicAccessData();
